import { render, staticRenderFns } from "./MenuItemDropdown.vue?vue&type=template&id=89dbf382&"
import script from "./MenuItemDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuItemDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports